// @core/stores/secret/SecretLeaseStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { secretApi } from '@core/api';
import type {
  LeaseResponse,
  ListLeasesResponse,
  RenewLeaseRequest,
  RevokeLeaseRequest,
} from '@core/types/secret';

class SecretLeaseStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * List leases
   */
  async ListLeases(params?: { cursor?: string | number | boolean; direction?: string | number | boolean; engine_id?: string | number | boolean; limit?: string | number | boolean; sort?: string | number | boolean; status?: string | number | boolean; }): Promise<ListLeasesResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await secretApi.ListLeases(params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Renew lease
   */
  async RenewLease(lease_id: string, data: RenewLeaseRequest): Promise<LeaseResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await secretApi.RenewLease(lease_id, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Revoke lease
   */
  async RevokeLease(lease_id: string, data: RevokeLeaseRequest): Promise<Response> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await secretApi.RevokeLease(lease_id, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const secretLeaseStore = new SecretLeaseStore();
